module.exports = __webpack_public_path__ + "img/accessory_hat_05.889d6ea8.svg";